/* ==========================================================================
   Kidea — kidea.js
   One dependency-free script for the whole shop, loaded with defer.
   Reveal on scroll, announcement rotation, header, mobile menu, cart drawer,
   AJAX add-to-cart, add-to-cart upsell pop-up, accordions, galleries, variant
   buttons, quantity steppers, sticky buy bars, the calendar bundle picker,
   reviews (filters, more, photo lightbox), count-up numbers, collection
   filters and sort. Everything clickable is delegated (COMMON-BUGS #9).
   ========================================================================== */
(function () {
  'use strict';
  var K = window.Kidea || { routes: {}, strings: {}, shipping: {} };
  var S = K.strings || {};
  var ROOT = (K.routes && K.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function headerH() {
    var h = qs('.k-header-section');
    return h ? h.getBoundingClientRect().height : 0;
  }
  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerH() - 14;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
  }

  /* ---------- Money: copy the shape of a price Liquid formatted (COMMON-BUGS #28) ---------- */
  var PROBE = (function () {
    var p = String(K.moneyProbe || '');
    var m = p.match(/^(.*?)(1[^\d]?234[^\d]?567(?:[^\d]89)?)(.*)$/);
    if (!m) return null;
    var num = m[2];
    var dec = /89$/.test(num) ? num.charAt(num.length - 3) : '';
    var th = num.charAt(1);
    if (/\d/.test(th)) th = '';
    return { prefix: m[1], suffix: m[3], th: th, dec: dec };
  })();
  function money(cents) {
    cents = Math.round(cents || 0);
    var whole = cents % 100 === 0;
    var v = Math.abs(cents) / 100;
    if (PROBE) {
      var fixed = v.toFixed(whole || !PROBE.dec ? 0 : 2).split('.');
      var w = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, PROBE.th);
      return (cents < 0 ? '-' : '') + PROBE.prefix + w + (fixed[1] ? PROBE.dec + fixed[1] : '') + PROBE.suffix;
    }
    return (cents < 0 ? '-' : '') + v.toFixed(whole ? 0 : 2);
  }
  window.KideaMoney = money;

  /* ---------- Scroll lock, derived from the DOM (COMMON-BUGS #7) ---------- */
  var OPEN_SEL = '.k-drawer.is-open, .k-menu.is-open, .k-popup.is-open, .k-filter.is-open, .k-lightbox.is-open';
  function syncLock() {
    document.documentElement.classList.toggle('k-locked', !!qs(OPEN_SEL));
  }
  var lastFocus = null;
  function openLayer(panel, overlay) {
    if (!panel) return;
    lastFocus = document.activeElement;
    panel.style.visibility = 'visible';
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    syncLock();
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeLayer(panel, overlay) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.style.visibility = ''; }, 420);
    syncLock();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- 1. Reveal on scroll (COMMON-BUGS #5: never gated on a library) ---------- */
  (function () {
    var items = qsa('.reveal');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var sib = el.parentElement ? qsa(':scope > .reveal', el.parentElement) : [el];
        var idx = Math.max(0, sib.indexOf(el));
        el.style.transitionDelay = Math.min(idx, 5) * 80 + 'ms';
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      qsa('.reveal:not(.is-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight + 120) el.classList.add('is-visible');
      });
    }, 2200);
  })();

  /* ---------- 2. Announcement rotation ---------- */
  (function () {
    var bar = qs('[data-announce]');
    if (!bar) return;
    var msgs = qsa('.k-announce__msg', bar);
    if (msgs.length < 2 || reduced) return;
    var i = 0, paused = false;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 5000);
  })();

  /* ---------- 3. Header shadow ---------- */
  (function () {
    var h = qs('[data-header]');
    if (!h) return;
    var on = false;
    function check() {
      var s = window.scrollY > 24;
      if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  /* ---------- 4. Mobile menu ---------- */
  var menu = qs('.k-menu');
  var menuOverlay = qs('.k-overlay--menu');
  function openMenu() {
    openLayer(menu, menuOverlay);
    qsa('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeMenu() {
    closeLayer(menu, menuOverlay);
    qsa('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  /* ---------- 5. Cart drawer ---------- */
  var drawer = qs('.k-drawer');
  var cartOverlay = qs('.k-overlay--cart');
  function openCart() { closeMenu(); openLayer(drawer, cartOverlay); }
  function closeCart() { closeLayer(drawer, cartOverlay); }

  var ICON_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="18" height="18" aria-hidden="true"><path d="M5 12h14"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="18" height="18" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="26" height="26" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v7.5h14v-7.5M12 8.5V20"/></svg>';

  function sizedImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var label = qs('[data-cart-count-label]', drawer);
    if (label) { label.textContent = cart.item_count; label.hidden = cart.item_count === 0; }
    var itemsEl = qs('[data-cart-items]', drawer);
    var foot = qs('[data-cart-foot]', drawer);
    var ship = qs('[data-cart-ship]', drawer);
    var ups = qs('[data-cart-ups]', drawer);
    if (!itemsEl) return;

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="k-empty"><span class="k-empty__icon" aria-hidden="true">' + ICON_GIFT + '</span><p>' +
        esc(S.empty) + '</p><a class="k-btn" href="' + esc(K.allUrl || ROOT + 'collections/all') + '"><span>' + esc(S.shopNow) + '</span></a></div>';
      if (foot) foot.hidden = true;
      if (ship) ship.hidden = true;
      if (ups) ups.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    if (ship) ship.hidden = false;

    var html = '';
    cart.items.forEach(function (it) {
      var variant = (it.variant_title && !it.product_has_only_default_variant) ? '<p class="k-line__variant">' + esc(it.variant_title) + '</p>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      html += '<div class="k-line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="k-line__media" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sizedImg(it.image, 180)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div class="k-line__info"><a class="k-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="k-line__row"><div class="k-qty k-qty--sm">' +
        '<button type="button" data-line-minus aria-label="' + esc(S.decrease) + '">' + ICON_MINUS + '</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-line-plus aria-label="' + esc(S.increase) + '">' + ICON_PLUS + '</button></div>' +
        '<div class="k-line__price">' + was + '<b>' + money(it.final_line_price) + '</b></div></div></div>' +
        '<button type="button" class="k-line__remove" data-line-remove aria-label="' + esc(S.remove) + '">' + ICON_CLOSE + '</button></div>';
    });
    itemsEl.innerHTML = html;

    // Cart upsells (snippets/k-cart-upsells.liquid): show the first N products
    // that are not in the bag yet; hide the block when none are left.
    if (ups) {
      var upMax = parseInt(ups.getAttribute('data-max'), 10) || 3;
      var upShown = 0;
      qsa('[data-cart-up]', ups).forEach(function (row) {
        var pid = parseInt(row.getAttribute('data-product-id'), 10);
        var inCart = cart.items.some(function (it) { return it.product_id === pid; });
        var show = !inCart && upShown < upMax;
        row.hidden = !show;
        if (show) upShown++;
      });
      ups.hidden = upShown === 0;
    }

    var shipCfg = K.shipping || {};
    var limit = shipCfg.threshold || 34900;
    var bar = qs('[data-cart-ship-bar]', drawer);
    var note = qs('[data-cart-ship-note] span', drawer);
    if (bar) bar.style.width = Math.min(100, cart.total_price / limit * 100) + '%';
    if (note) {
      note.textContent = cart.total_price >= limit
        ? (shipCfg.reached || '')
        : String(shipCfg.remaining || '').replace('@@AMOUNT', money(limit - cart.total_price));
    }
    if (ship) ship.classList.toggle('is-done', cart.total_price >= limit);
    var total = qs('[data-cart-total]', drawer);
    if (total) total.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; })
      .catch(function () {});
  }
  function changeLine(key, qty, line) {
    if (line) line.classList.add('is-busy');
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { if (line) line.classList.remove('is-busy'); });
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.k-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
      if (e.target.closest('[data-line-plus]')) changeLine(key, qty + 1, line);
      else if (e.target.closest('[data-line-minus]')) changeLine(key, qty - 1, line);
      else if (e.target.closest('[data-line-remove]')) changeLine(key, 0, line);
    });
  }

  /* ---------- 6. Add to cart ---------- */
  function setBtn(btn, state) {
    if (!btn) return;
    if (state === 'busy') {
      btn.setAttribute('data-html', btn.innerHTML);
      btn.disabled = true;
      btn.classList.add('is-busy');
    } else {
      btn.classList.remove('is-busy');
      if (state === 'done') {
        btn.classList.add('is-added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg><span>' + esc(S.added) + '</span>';
      }
      setTimeout(function () {
        var h = btn.getAttribute('data-html');
        if (h) btn.innerHTML = h;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, state === 'done' ? 1500 : 0);
    }
  }
  function toast(msg) {
    var t = qs('.k-toast');
    if (!t) { t = document.createElement('div'); t.className = 'k-toast'; t.setAttribute('role', 'alert'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    setTimeout(function () { t.classList.remove('is-on'); }, 3500);
  }

  function addToCart(items, btn, opts) {
    opts = opts || {};
    setBtn(btn, 'busy');
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          setBtn(btn, 'error');
          toast((res.data && (res.data.description || res.data.message)) || S.addError || '');
          return;
        }
        setBtn(btn, 'done');
        var badge = qs('.k-cartbtn');
        if (badge && !reduced) { badge.classList.remove('is-bump'); void badge.offsetWidth; badge.classList.add('is-bump'); }
        var pid = res.data && res.data.items && res.data.items[0] ? res.data.items[0].product_id : null;
        return fetchCart().then(function () {
          if (opts.quiet) return;
          if (opts.upsell !== false && pid) showUpsell(pid); else openCart();
        });
      })
      .catch(function () { setBtn(btn, 'error'); toast(S.addError || ''); });
  }
  window.KideaAddToCart = addToCart;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var q = form.querySelector('[name="quantity"]');
    var inPopup = !!form.closest('[data-upsell]');
    var inDrawer = !!form.closest('.k-drawer');
    addToCart([{ id: parseInt(id.value, 10), quantity: q ? Math.max(1, parseInt(q.value, 10) || 1) : 1 }],
      form.querySelector('[type="submit"]'),
      { upsell: !inPopup && !inDrawer && !form.hasAttribute('data-no-upsell'), quiet: inPopup || inDrawer });
  });

  /* ---------- 7. Upsell pop-up ---------- */
  var upsell = qs('[data-upsell]');
  function closeUpsell() { closeLayer(upsell, null); }
  function showUpsell(pid) {
    if (!upsell) { openCart(); return; }
    var list = qs('[data-upsell-items]', upsell);
    fetch(ROOT + 'recommendations/products?section_id=k-recommendations&limit=6&intent=related&product_id=' + pid, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var tmp = document.createElement('div');
        tmp.innerHTML = txt;
        var found = qs('[data-rec-list]', tmp);
        if (found) {
          qsa('[data-product-id="' + pid + '"]', found).forEach(function (n) { n.remove(); });
        }
        if (found && found.children.length) {
          list.innerHTML = found.innerHTML;
          openLayer(upsell, null);
        } else {
          openCart();
        }
      })
      .catch(openCart);
  }
  if (upsell) {
    upsell.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-cart]')) { closeUpsell(); openCart(); return; }
      if (e.target.closest('[data-upsell-close]')) closeUpsell();
    });
  }

  /* ---------- 8. Global click routing ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-menu-close]')) { closeMenu(); return; }
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); fetchCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }

    var jump = t.closest('[data-jump-bundle]');
    if (jump) {
      var b = qs('#bundle');
      if (b) { e.preventDefault(); scrollToEl(b); b.classList.remove('is-flash'); void b.offsetWidth; b.classList.add('is-flash'); }
      return;
    }
    var to = t.closest('[data-scroll-to]');
    if (to) {
      var target = qs(to.getAttribute('data-scroll-to'));
      if (target) { e.preventDefault(); scrollToEl(target); }
      return;
    }

    var acc = t.closest('[data-acc]');
    if (acc) {
      var open = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = acc.nextElementSibling;
      if (panel) panel.classList.toggle('is-open', !open);
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var box = step.closest('[data-qty]');
      var input = box && qs('input', box);
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + (parseInt(step.getAttribute('data-qty-step'), 10) || 1);
      input.value = Math.max(1, Math.min(99, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeUpsell(); closeCart(); closeMenu();
    var f = qs('.k-filter.is-open'); if (f) closeLayer(f, qs('.k-overlay--filter'));
    var lb = qs('.k-lightbox.is-open'); if (lb) closeLayer(lb, null);
  });

  /* ---------- 9. Galleries (stacked slides, COMMON-BUGS #13) ---------- */
  qsa('[data-gallery]').forEach(function (gal) {
    var slides = qsa('[data-slide]', gal);
    var thumbs = qsa('[data-thumb]', gal);
    var count = qs('[data-gal-count]', gal);
    var rail = qs('[data-gal-thumbs]', gal);
    if (!slides.length) return;
    var cur = 0;
    function hydrate(s) {
      var img = s && qs('img[data-src]', s);
      if (!img) return;
      if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    }
    function show(i) {
      cur = (i + slides.length) % slides.length;
      hydrate(slides[cur]); hydrate(slides[(cur + 1) % slides.length]);
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); });
      thumbs.forEach(function (th, n) { th.classList.toggle('is-active', n === cur); });
      if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
      var at = thumbs[cur];
      if (rail && at) {
        var want = at.offsetLeft - (rail.clientWidth - at.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, want), behavior: reduced ? 'auto' : 'smooth' });
      }
    }
    gal._show = show;
    gal.addEventListener('click', function (e) {
      if (e.target.closest('[data-gal-prev]')) { show(cur - 1); return; }
      if (e.target.closest('[data-gal-next]')) { show(cur + 1); return; }
      var th = e.target.closest('[data-thumb]');
      if (th) show(parseInt(th.getAttribute('data-thumb'), 10) || 0);
    });
    var stage = qs('.k-gal__stage', gal);
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) show(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    gal._showImage = function (imageId) {
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-image-id') === String(imageId)) { show(i); return; }
    };
  });

  /* ---------- 10. Sticky buy bar ---------- */
  function sticky(anchor) {
    var bar = qs('[data-sticky]');
    if (!bar || !anchor) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      var past = r.bottom < headerH();
      var footer = qs('.k-footer');
      var atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight - 40;
      var on = past && !atFooter;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      qsa('button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      document.body.classList.toggle('has-sticky', on);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- 11. Default product page: option buttons ---------- */
  (function () {
    var root = qs('[data-product-root]');
    if (!root) return;
    var data = null;
    try { data = JSON.parse(qs('[data-product-json]', root).textContent); } catch (e) {}
    var form = qs('[data-product-form]', root);
    if (!data || !form) return;
    var input = qs('[data-variant-input]', form);
    var priceEl = qs('[data-price]', root);
    var compareEl = qs('[data-compare]', root);
    var pill = qs('[data-save-pill]', root);
    var atc = qs('[data-atc]', form);
    var atcLabel = qs('[data-atc-label]', form);
    var stickyTotal = qs('[data-sticky-total]', root);
    var stickyBtn = qs('[data-sticky-submit]', root);
    var gal = qs('[data-gallery]', root);

    function chosen() {
      return qsa('[data-option-index]', form).map(function (fs) {
        var a = qs('.k-vbtn.is-active', fs);
        return a ? a.getAttribute('data-value') : null;
      });
    }
    function update() {
      var ch = chosen();
      var match = data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return ch[i] == null || o === ch[i]; });
      })[0];
      if (!match) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = S.soldOut || '';
        return;
      }
      if (input) input.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (stickyTotal) stickyTotal.textContent = money(match.price);
      var sale = match.compare > match.price;
      if (compareEl) { compareEl.hidden = !sale; if (sale) compareEl.textContent = money(match.compare); }
      if (pill) {
        pill.hidden = !sale;
        if (sale) pill.textContent = String(S.savePct || '@@PCT%').replace('@@PCT', Math.round((match.compare - match.price) / match.compare * 100));
      }
      if (atc) atc.disabled = !match.available;
      if (stickyBtn) stickyBtn.disabled = !match.available;
      if (atcLabel) atcLabel.textContent = match.available ? (S.addToCart || '') : (S.soldOut || '');
      if (match.image && gal && gal._showImage) gal._showImage(match.image);
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState(null, '', u.toString());
      }
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-option-btn]');
      if (!b) return;
      var fs = b.closest('[data-option-index]');
      qsa('[data-option-btn]', fs).forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var lbl = qs('[data-option-value]', fs);
      if (lbl) lbl.textContent = b.getAttribute('data-value');
      update();
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    sticky(atc);
  })();

  /* ---------- 12. Calendar bundle picker + tree add-on ---------- */
  (function () {
    var root = qs('[data-bundle-root]');
    if (!root) return;
    var bundle = qs('[data-bundle]', root);
    if (!bundle) return;
    var tiers = qsa('[data-tier]', bundle);
    var totalEls = qsa('[data-bundle-total]', root);
    var saveEl = qs('[data-bundle-save]', root);
    var stickyTotal = qs('[data-sticky-total]', root);
    var stickyTier = qs('[data-sticky-tier]', root);
    var treeVariant = null;
    try { treeVariant = JSON.parse(qs('[data-tree-json]', bundle).textContent).variant; } catch (e) {}
    var variantId = parseInt(bundle.getAttribute('data-variant'), 10);

    function current() { return qs('[data-tier].is-selected', bundle) || tiers[0]; }
    function compute() {
      var t = current();
      if (!t) return;
      var total = parseInt(t.getAttribute('data-total'), 10) || 0;
      var was = parseInt(t.getAttribute('data-was'), 10) || 0;
      var check = qs('[data-tree-check]', t);
      if (check && check.checked) {
        total += parseInt(t.getAttribute('data-tree-total'), 10) || 0;
        was += parseInt(t.getAttribute('data-tree-was'), 10) || 0;
      }
      totalEls.forEach(function (el) { el.textContent = money(total); });
      if (stickyTotal) stickyTotal.textContent = money(total);
      if (stickyTier) {
        var nm = qs('.k-tier__name', t);
        stickyTier.textContent = nm ? nm.childNodes[0].textContent.trim() : '';
      }
      if (saveEl) {
        var save = was - total;
        saveEl.hidden = !(save > 0);
        if (save > 0) saveEl.textContent = String(S.youSave || '@@AMOUNT').replace('@@AMOUNT', money(save));
      }
    }
    function select(t) {
      tiers.forEach(function (x) {
        var on = x === t;
        x.classList.toggle('is-selected', on);
        var head = qs('[data-tier-btn]', x);
        if (head) head.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!on) { var c = qs('[data-tree-check]', x); if (c) c.checked = false; }
      });
      compute();
    }
    bundle.addEventListener('click', function (e) {
      var head = e.target.closest('[data-tier-btn]');
      if (head) select(head.closest('[data-tier]'));
    });
    bundle.addEventListener('change', function (e) {
      if (e.target.matches('[data-tree-check]')) {
        var t = e.target.closest('[data-tier]');
        if (!t) return;
        if (!t.classList.contains('is-selected')) select(t);
        t.classList.toggle('has-addon', e.target.checked);
        compute();
      }
    });
    root.addEventListener('click', function (e) {
      var vb = e.target.closest('[data-variant-id]');
      if (!vb) return;
      variantId = parseInt(vb.getAttribute('data-variant-id'), 10);
      qsa('[data-variant-id]', root).forEach(function (b) {
        b.classList.toggle('is-active', b === vb);
        b.setAttribute('aria-pressed', b === vb ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bundle-add]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var t = current();
      var units = parseInt(t.getAttribute('data-units'), 10) || 1;
      var items = [{ id: variantId, quantity: units }];
      var check = qs('[data-tree-check]', t);
      if (check && check.checked && treeVariant) {
        items.push({ id: treeVariant, quantity: parseInt(t.getAttribute('data-tree-qty'), 10) || units });
      }
      addToCart(items, btn, { upsell: true });
    });
    compute();
    sticky(qs('[data-bundle-add]', bundle));
  })();

  /* ---------- 13. Reviews ---------- */
  qsa('[data-reviews]').forEach(function (sec) {
    var bars = qsa('[data-bar]', sec);
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { sec.classList.add('bars-on'); io.disconnect(); }
      }, { threshold: 0.2 });
      io.observe(sec);
    } else sec.classList.add('bars-on');
    var more = qs('[data-rev-more]', sec);
    function all() { qsa('.k-review.is-extra', sec).forEach(function (c) { c.classList.remove('is-extra'); }); if (more) more.parentElement.hidden = true; }
    if (more) more.addEventListener('click', all);
    sec.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-rev-filter]');
      if (chip) {
        var want = chip.getAttribute('data-rev-filter');
        qsa('[data-rev-filter]', sec).forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        all();
        qsa('.k-review', sec).forEach(function (card) {
          var ok = want === 'all' || (want === 'photo' && card.hasAttribute('data-photo')) || card.getAttribute('data-stars') === want;
          card.hidden = !ok;
        });
        return;
      }
      var ph = e.target.closest('[data-rev-photo]');
      var lb = qs('[data-lightbox]', sec);
      if (ph && lb) {
        qs('[data-lightbox-img]', lb).src = ph.getAttribute('data-rev-photo');
        openLayer(lb, null);
        return;
      }
      if (e.target.closest('[data-lightbox-close]')) closeLayer(qs('[data-lightbox]', sec), null);
    });
    void bars;
  });

  /* ---------- 14. Count-up numbers ---------- */
  (function () {
    var nums = qsa('[data-countup]');
    if (!nums.length) return;
    function run(el) {
      var raw = el.getAttribute('data-countup');
      var target = parseFloat(String(raw).replace(',', '.'));
      if (isNaN(target) || reduced) return;
      var dec = (String(raw).split(/[.,]/)[1] || '').length;
      var t0 = null;
      function fmt(v) {
        var s = v.toFixed(dec);
        return dec ? s : s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      requestAnimationFrame(function stepFn(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 1400);
        el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(stepFn);
      });
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { run(x.target); io.unobserve(x.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  })();

  /* ---------- 15. Collection: sort + filter drawer ---------- */
  (function () {
    var sort = qs('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.assign(u.toString());
    });
    var f = qs('.k-filter');
    var ov = qs('.k-overlay--filter');
    if (!f) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { e.preventDefault(); openLayer(f, ov); return; }
      if (e.target.closest('[data-filter-close]')) closeLayer(f, ov);
    });
  })();

  /* ---------- 16. Keep the bag count right after back/forward navigation ---------- */
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });
})();
